import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Header from './common/AppHeader';
import ResponsiveSideMenu from './common/Sidebar';

import AppTheme from './shared-theme/AppTheme';
import { AppAlertBox } from './AppAlertBox';

import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';

import { CustomRoute } from "./CustomRoute";
import { ContinueSession } from "./ContinueSession";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export { AppLayout };

function AppLayout(props) {
  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      {/* <CssBaseline enableColorScheme /> */}
      <CssBaseline />
      <Box sx={{ display: 'flex' }}>
        <ContinueSession open={true} />
        {/* <SideMenu /> */}
        {/* <AppNavbar /> */}
        <ResponsiveSideMenu />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            // backgroundColor: theme.vars
            //   ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            //   : alpha(theme.palette.background.default, 1),
            backgroundImage: "url('../assets/images/healthcare/bgimg.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            overflow: 'auto',
          })}

        >
          <Stack
            sx={{
              // alignItems: 'center',
              //              mx: 3,
              //              pb: 10,
              // mt: { xs: 8, md: 0.5 },
              mm: { xs: 8, md: 0.5 },
            }}
          >
            <Header />
            {/*<MainGrid />*/}
            <AppAlertBox />
            <CustomRoute />
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}
